var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8969 25.0963C12.9351 24.7517 12.9543 24.5794 13.0064 24.4184C13.0527 24.2755 13.118 24.1396 13.2007 24.0142C13.2939 23.8729 13.4165 23.7503 13.6616 23.5052L24.6669 12.4999C25.5873 11.5795 27.0797 11.5795 28.0002 12.4999C28.9207 13.4204 28.9207 14.9128 28.0002 15.8333L16.9949 26.8385C16.7498 27.0836 16.6272 27.2062 16.4859 27.2994C16.3605 27.3821 16.2246 27.4474 16.0817 27.4937C15.9207 27.5458 15.7484 27.5649 15.4038 27.6032L12.5835 27.9166L12.8969 25.0963Z",
    stroke: "#535862",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton2);
export default __webpack_public_path__ + "static/media/button-2.69a81a5607d19e8f7281edd7f5e6d6b5.svg";
export { ForwardRef as ReactComponent };